import { useNavigate } from "react-router-dom";
import PageLayout from "../components/PageLayout"
import { useEffect, useState } from "react";

// icons 
import IconComponent from "../components/Icon";
import { BsFillBookmarkCheckFill } from "react-icons/bs";
import { FiInfo } from "react-icons/fi";
import { GiCheckMark } from "react-icons/gi";
import { FaPlus, FaSearch } from "react-icons/fa";

// services
import axiosInstance from "../api/apiClient";
import { IoMdClose } from "react-icons/io";
import Book from "../components/Book";
import { book } from "../assets/data/constants";


const noCover = 'https://dryofg8nmyqjw.cloudfront.net/images/no-cover.png';

const  Browse = () => {
      const navigate = useNavigate();
      const [library, setLibrary] = useState([]);
      const [searchString, setSearchString] = useState('');
      const [hideLibraryBooks, setHideLibraryBooks] = useState(true);

      const getLibraryData = async () => {
        await axiosInstance.get('/getAllBooks').then((data:any) => {
          setLibrary(data);
        });
      };

      useEffect(() => {
        getLibraryData();
      }, []);



    return (
        <PageLayout
            headerText="Browse"
            type="dark"
        >
            <div className="bg-white rounded-3xl shadow-lg p-4 min-h-20 mt-[40px]">
                <div 
                    className="grid grid-cols-1 md:grid-cols-3 gap-4"
                >
                    <form className="flex items-center" onSubmit={(e) => e.preventDefault() }>
                        <div className="relative">
                            <input type="text" placeholder="Search" className="p-2 rounded-lg border border-gray-300 focus:outline-none focus:border-[#8784D8]" value={searchString} onChange={(e) => setSearchString(e.target.value)}/>
                            {searchString.length > 0 && 
                                <button type="button" style={{position: 'absolute', right: 0}} className="ml-2 p-2 h-full rounded-lg" onClick={() => setSearchString('')}>
                                    <IconComponent icon={IoMdClose} width={20} color="#60637A" className="drop-shadow-sm"/>
                                </button>
                            }
                        </div>
                        
                        
                        <button type="submit"  className="ml-2 p-2 h-full rounded-lg  text-white focus:outline-none">
                            <IconComponent icon={FaSearch} width={20} color="#8784D8" className="drop-shadow-sm hover:color-[#6c6aad]"/>
                        </button>

                         
            
                    </form>

                    <div className="flex items-center justify-center ml-4 p-2 rounded-lg" onClick={() => setHideLibraryBooks(!hideLibraryBooks)}>     
                            
                        <input checked={hideLibraryBooks}  type="checkbox" placeholder="" className="p-2 rounded-lg border border-gray-300 focus:outline-none focus:border-[#8784D8]"/>
                        <label className="text-gray-600 ml-4">Hide Books already in library</label>
                    </div>
                    
                   
                </div>
                <div className="grid grid-cols-2 md:grid-cols-6 gap-4 mt-[40px]">
                    {/* TODO: Add book admin only?  */}
                     <div className="relative w-32 h-48" onClick={() => navigate('/add-book')}>
                    
                        <div className="w-32 h-48 bg-[var(--dark-grey)] rounded-lg flex items-center justify-center">
                            <p className="text-white text-center">
                            <IconComponent icon={FaPlus} width={30} color="#ffffff" className="drop-shadow-xl"/>
                            </p>
                        </div>
        
                        <div className="absolute top-0 left-0 right-0 bottom-0 h-full bg-black bg-opacity-50 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300 rounded-lg cursor-pointer">
                            <p className="text-white text-center">
                            <IconComponent icon={FaPlus} width={30} color="#ffffff" className="drop-shadow-xl" />
                            </p>
                        </div>
        
                    </div>
                    {library.filter((book: any) => {return hideLibraryBooks ? !book['In User Library'] : true}).filter((book: any) => book['Title'].toLowerCase().includes(searchString.toLowerCase()) || book['Author'].toLowerCase().includes(searchString.toLowerCase()))
                            .map((book: book, key: any) => {
                            return (
                                <Book book={book} key={key} />
                            )
                    })}
                </div>
            </div>
        </PageLayout>
    )
    
}

export default Browse